/* eslint-disable no-lone-blocks */
import React from "react";
import { Route, Redirect } from "react-router-dom";
import ls from "local-storage";

const ProtectedRoute = ({ component: Component, path, ...rest }) => {
  const role = ls("roles");
  const User = ls("user");
  const thisPath = path;

  const userAccess = ls("userAccess") || [];
  const authToken = ls("authToken");
  const normalizedPath = (thisPath || "/").replace(/\/+$/, "") || "/";
  const isValidAuthToken =
    authToken &&
    authToken !== false &&
    authToken !== "false" &&
    authToken !== "null" &&
    authToken !== "undefined";

  const getLoginRedirectPath = () => {
    try {
      const storedRoute = window.sessionStorage.getItem("postLogoutLoginRoute");
      return ["/login"].includes(storedRoute)
        ? storedRoute
        : "/login";
    } catch (error) {
      return "/login";
    }
  };

  const permissionPathMap = {
    "Dashboard.Timeshow": "/dashboard",
    "Permission.Show": "/permission",
    "Users.Show": "/users",
    "Users.View": "/users/:userId",
    "Role.Show": "/role",
    "Users.Add": "/users/add",
    "Users.Edit": "/users/edit/:id",
    "Role.Edit": "/role/edit/:id",
    "Dashboard.Birthday": "/dashboard",
    "Dashboard.Upcomingevent": "/dashboard",
    "Permission.Add": "/permission",
    "Permission.Edit": "/permission",
    "Permission.Delete": "/permission",
    "Role.Add": "/role/add",
    "Role.Delete": "/role",
    "Users.Delete": "/users",
    "Users.Status": "/users",
    "Holidays.Add": "/holiday-leaves/add",
    "Holidays.Show": "/holiday-leaves",
    "Holidays.Edit": "/holiday-leaves/edit/:id",
    "Holidays.Delete": "/holiday-leaves",
    "Upcomingevent.Add": "/upcoming-event/add",
    "Form360.Add": "/form360",
    "Reviewformadd.Add": "/review-form-add",
    "Reviewformadd.Show": "/review-form-list",
    "Reviewformadd.Edit": "/review-form-edit/:id",


    "Upcomingevent.Show": "/upcoming-event",
    "Upcomingevent.Edit": "/upcoming-event/edit/:id",
    // "Upcomingevent.delete": "/upcoming",
    "Leaveticket.Add": "/leave-tickets/add",
    "Leaveticket.Show": "/leave-tickets",
    "Leaveticket.Edit": "/leave-tickets/edit/:id",
    "Leaveticket.Delete": "/leave-tickets",
    "Leaveticket.Approve": "/leave-tickets",
    "Leaveticket.Declined": "/leave-tickets",
    "Leaveticket.Cancel": "/leave-tickets",
    "Leaveticket.Viewdetails": "/leave-tickets",
    "Job.Add": "/job/add",
    "Job.Show": "/job",
    "Job.Edit": "/job/edit/:id",
    "Job.Delete": "/job",

    "Qualification.Add": "/qulification/add",
    "Qualification.Show": "/qulification",
    "Qualification.Edit": "/qulification/edit/:id",
    "Qualification.Delete": "/qulification",



    "designation.Add": "/designation/add",
    "designation.Show": "/designation",
    "designation.Edit": "/designation/edit/:id",



    "Department.Show": "/Departmente",
    "Department.Add": "/Departmente/add",
    "Department.Edit": "/Departmente/edit/:id",
    // "Qualification.Delete": "/qulification",


    "Experience.Show": "/experience",
    "Experience.Add": "/experience/add",
    "Experience.Edit": "/experience/edit/:id",
    "Experience.Delete": "/experience",
    "Time.Add": "/time-entries/add",
    "Timeentry.Show": "/time-entries",
    "Timeentry.Approve": "/time-entries",
    "Timeentry.Reject": "/time-entries",
    "Offerletter.Add": "/documents/offer-latter-add",
    "Offerletter.Show": "/documents/offer-letter",
    "Offerletter.View": "/documents/offer-letter",
    "Offerletter.Download": "/documents/offer-letter",
    "Offerletter.Delete": "/documents/offer-letter",
    "Salaryslip.Show": "/documents/salary-slip",
    "Salaryslip.View": "/documents/salary-slip",
    "Salaryslip.Download": "/documents/salary-slip",
    "Salaryslip.Delete": "/documents/salary-slip",
    "Relievingletter.Add": "/documents/relieving-letter-add",
    "Relievingletter.Show": "/documents/relieving-letter",
    "Relievingletter.Approve": "/documents/relieving-letter",
    "Relievingletter.Reject": "/documents/relieving-letter",
    "Relievingletter.View": "/documents/relieving-letter",
    "Relievingletter.Download": "/documents/relieving-letter",
    "Relievingletter.Delete": "/documents/relieving-letter",
    "Template.Add": "/templates/add",
    "Template.Show": "/templates",
    "Template.Edit": "/templates/edit/:id",
    "Template.Delete": "/templates",
    "Template.Status": "/templates",
    "Cron.Show": "/cron",
    "Cron.Dailycron": "/cron",
    "Cron.Salarycron": "/cron",
    "Documentslist.Show": "/documents/documents-list",
    "Profile.Show": "/profile",
    "Attendance.Show": "/attendance",
    "Settings.Show": "/settings",
    "Settings.WorkingHoursView": "/settings",
    "Settings.LeaveSettingsView": "/settings",
    "Settings.NotificationsView": "/settings",
    "Settings.ReminderSettingsView": "/settings",
    "Settings.ReviewFormSettingsView": "/settings",
    "DetailedNotifications.Show": "/detailed-notifications",

    // "Forgotpassword.Show": "/Forgotpassword",
    "Emailtemplates.Show": "/email-templates",
    "Emailtemplates.Add": "/add-email-template",
    "Emailtemplates.Edit": "/edit-email-template/:id",
    "Emailtemplates.Delete": "/email-templates",
    "Emailtemplates.Status": "/email-templates",

    "Tasks.Add": "/tasks/add",
    "Tasks.Show": "/tasks",
    "Tasks.Edit": "/task/edit/:id",
    "Tasks.History": "/tasks/history",

    "Project.Add": "/project/add",
    "Project.Show": "/project",
    "Project.Edit": "/project/edit/:id",
    "Project.Delete": "/project",
    "Project.View": "/project/:id",
    "Chat.Show": "/chat",

  };

  return (
    <Route
      {...rest}
      render={(props, id) => {
        // If not authenticated, redirect to login immediately
        if (!isValidAuthToken) {
          return (
            <Redirect
              to={{
                pathname: getLoginRedirectPath(),
                state: { from: props.location },
              }}
            />
          );
        }

        const isSuperAdmin =
          role === "Super Admin" ||
          (Array.isArray(role) &&
            role.some(
              (r) =>
                (typeof r === "string" && r.toLowerCase() === "super admin") ||
                (typeof r === "object" && (r.name || "").toLowerCase() === "super admin")
            )) ||
          (User && User.roles && Array.isArray(User.roles) &&
            User.roles.some(
              (r) =>
                (typeof r === "string" && r.toLowerCase() === "super admin") ||
                (typeof r === "object" && (r.name || "").toLowerCase() === "super admin")
            ));

        const isTasksRoute =
          normalizedPath === "/tasks" ||
          normalizedPath === "/tasks/history" ||
          normalizedPath === "/tasks/add" ||
          normalizedPath === "/addtask" ||
          normalizedPath === "/tasks/addtask" ||
          normalizedPath === "/addproject" ||
          normalizedPath === "/tasks/addproject" ||
          normalizedPath === "/tasks/add/project" ||
          normalizedPath === "/manageproject" ||
          normalizedPath === "/tasks/manageproject" ||
          normalizedPath === "/tasks/manage/project" ||
          normalizedPath.startsWith("/editproject") ||
          normalizedPath.startsWith("/tasks/editproject") ||
          normalizedPath.startsWith("/tasks/edit/project") ||
          normalizedPath.startsWith("/task/edit");

        const hasTaskPermission =
          isSuperAdmin ||
          userAccess.includes("Tasks.Show") ||
          userAccess.includes("Tasks.Add") ||
          userAccess.includes("Tasks.Edit") ||
          userAccess.includes("Tasks.Delete") ||
          userAccess.includes("Tasks.History") ||
          userAccess.includes("TaskManagement.Show") ||
          userAccess.includes("Task Management.Show");

        const hasTaskAccess = isTasksRoute && isValidAuthToken && hasTaskPermission;

        const hasPermission = Object.entries(permissionPathMap).some(
          ([permission, path]) => userAccess.includes(permission) && normalizedPath === ((path || "/").replace(/\/+$/, "") || "/")
        );

        const hasDepartmentRouteFallback =
          normalizedPath === "/Departmente/add" &&
          (
            userAccess.includes("Department.Add") ||
            userAccess.includes("Department.Show") ||
            userAccess.includes("Department.Edit")
          );

        const hasDepartmentEditFallback =
          normalizedPath === "/Departmente/edit/:id" &&
          (
            userAccess.includes("Department.Edit") ||
            userAccess.includes("Department.Show")
          );

        if (isSuperAdmin || hasPermission || hasTaskAccess || hasDepartmentRouteFallback || hasDepartmentEditFallback) {
          return <Component {...rest}  {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: getLoginRedirectPath(),
                state: { from: props.location },
              }}
            />
          );
        }


        // if (role === "Super Admin") {

        //   if (

        //     thisPath === "/permission" ||
        //     thisPath === "/role" ||
        //     thisPath === "/users" ||
        //     thisPath === "/users/edit/:id" ||
        //     thisPath === "/Page/edit/:id" ||
        //     thisPath === "/users/add" ||
        //     thisPath === "/leaves" ||
        //     thisPath === "/leaves/add" ||
        //     thisPath === "/leaves/edit/:id" ||
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/upcoming" ||
        //     thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time" ||
        //     thisPath === "/check" ||
        //     thisPath === "/offer" ||
        //     thisPath === "/latter" ||
        //     thisPath === "/Edittemplate/:id" ||
        //     thisPath === "/OfferLatter" ||
        //     thisPath === "/Salaryslip" ||
        //     thisPath === "/Documentslist" ||
        //     thisPath === "/Relievingletter" ||
        //     thisPath === "/message" ||
        //     thisPath === "/timer" ||
        //     // thisPath === "/Documents/OfferLatterAdd" ||
        //     // thisPath === "/Documents/Relievingletteradd" ||
        //     thisPath === "/testing" ||
        //     thisPath === "/Cron"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // } else if (role === "Hr") {
        //   if (
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/profile/edit" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/show/:id" ||
        //     thisPath === "/upcoming" ||
        //     thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // } else if (role === "Admin") {
        //   if (
        //     thisPath === "/permission" ||
        //     thisPath === "/role" ||
        //     thisPath === "/users" ||
        //     thisPath === "/users/edit/:id" ||
        //     thisPath === "/users/add" ||
        //     thisPath === "/leaves" ||
        //     thisPath === "/leaves/add" ||
        //     thisPath === "/leaves/edit/:id" ||
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/show/:id" ||
        //     thisPath === "/upcoming" ||
        //     thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time" ||
        //     thisPath === "/check" ||
        //     thisPath === "/offer" ||
        //     thisPath === "/latter" ||
        //     thisPath === "/OfferLatter" ||
        //     thisPath === "/message"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // }
        // else if (role === "karmur") {
        //   if (
        //     thisPath === "/permission" ||
        //     thisPath === "/role" ||
        //     thisPath === "/users" ||
        //     thisPath === "/users/edit/:id" ||
        //     thisPath === "/users/add" ||
        //     thisPath === "/leaves" ||
        //     thisPath === "/leaves/add" ||
        //     thisPath === "/leaves/edit/:id" ||
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/show/:id" ||
        //     thisPath === "/upcoming" ||
        //     thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time" ||
        //     thisPath === "/check" ||
        //     thisPath === "/offer" ||
        //     thisPath === "/latter" ||
        //     thisPath === "/OfferLatter" ||
        //     thisPath === "/message"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // } else if (role === "Administrator") {
        //   if (
        //     thisPath === "/permission" ||
        //     thisPath === "/role" ||
        //     thisPath === "/users" ||
        //     thisPath === "/users/edit/:id" ||
        //     thisPath === "/users/add" ||
        //     thisPath === "/leaves" ||
        //     thisPath === "/leaves/add" ||
        //     thisPath === "/leaves/edit/:id" ||
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/show/:id" ||
        //     thisPath === "/upcoming" ||
        //     thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // } else if (role === "Employee") {
        //   if (
        //     thisPath === "/tickets" ||
        //     thisPath === "/tickets/add" ||
        //     thisPath === "/tickets/edit/:id" ||
        //     thisPath === "/profile" ||
        //     thisPath === "/profile/edit" ||
        //     thisPath === "/event" ||
        //     thisPath === "/event/add" ||
        //     thisPath === "/event/edit/:id" ||
        //     thisPath === "/show/:id" ||
        //     thisPath === "/upcoming" ||
        //     // thisPath === "/upcoming/add" ||
        //     thisPath === "/upcoming/edit/:id" ||
        //     thisPath === "/job" ||
        //     thisPath === "/job/add" ||
        //     thisPath === "/leaves" ||
        //     thisPath === "/job/edit/:id" ||
        //     thisPath === "/qulification" ||
        //     thisPath === "/qulification/add" ||
        //     thisPath === "/qulification/edit/:id" ||
        //     thisPath === "/experience" ||
        //     thisPath === "/experience/add" ||
        //     thisPath === "/experience/edit/:id" ||
        //     thisPath === "/time"
        //   ) {
        //     return <Component {...rest} {...props} />;
        //   } else {
        //     return (
        //       <Redirect
        //         to={{
        //           path: "/login",
        //           location: props.location,
        //         }}
        //       />
        //     );
        //   }
        // } else {
        //   return (
        //     <Redirect
        //       to={{
        //         path: "/login",
        //         location: props.location,
        //       }}
        //     />
        //   );
        // }
      }}
    />

  );
};
export default ProtectedRoute;
